import { ComposedElement } from '@hyper-inferno/survey-elements-core-utils';
import Ajv from 'ajv';

export function coerecedPayloadBuilder(
  answerPayload: any,
  question: ComposedElement,
) {
  const meta = question.questionMeta;
  if (!meta) return answerPayload;

  // 1. Build AJV Schema from Question Meta
  const properties: any = {};
  const required: string[] = [];

  for (const [key, value] of Object.entries(meta as any)) {
    const val = value as any;
    properties[key] = { ...val.schema };

    // Clean up internal schema artifacts
    delete properties[key].items;

    // Handle Enums/ValueLabels
    if (val.schema?.valueLabels) {
      properties[key]['enum'] = Object.keys(val.schema.valueLabels).map(Number);
      delete properties[key]['valueLabels'];
    }

    if (val.schema?.default !== undefined) {
      required.push(key);
    }
  }

  const ajvSchema = { type: 'object', properties, required };

  // 2. Special Case: Complex types that might need manual coercion
  //   if (question.type === 'grid' || question.type === 'flow') {
  //     return applyDefaultsAndCoerce(ajvSchema, answerPayload);
  //   }

  // 3. Standard AJV Coercion
  const ajv = new Ajv({ coerceTypes: true, useDefaults: true });
  const validate = ajv.compile(ajvSchema);
  const dataClone = { ...answerPayload };

  const valid = validate(dataClone);

  if (valid) {
    return dataClone;
  } else {
    // If AJV fails, we use our manual fallback instead of crashing
    return applyDefaultsAndCoerce(ajvSchema, answerPayload);
  }
}

/**
 * Fallback Manual Coercion
 */
function applyDefaultsAndCoerce(schema: any, payload: any) {
  const result: any = {};
  for (const [key, prop] of Object.entries(schema.properties || {})) {
    let value = payload[key] ?? (prop as any).default;

    if (value !== undefined && (prop as any).type) {
      switch ((prop as any).type) {
        case 'number':
        case 'integer':
          value = Number(value);
          if (isNaN(value)) value = (prop as any).default;
          break;
        case 'boolean':
          value =
            typeof value === 'string'
              ? value.toLowerCase() === 'true'
              : Boolean(value);
          break;
        case 'string':
          value = String(value);
          break;
      }
    }
    result[key] = value;
  }
  return result;
}
